import { blockDataByBlockType } from 'shared-helpers/consts';

export default {
  audio: blockDataByBlockType.audio,
  discussion: blockDataByBlockType.discussion,
  embedcode: blockDataByBlockType.embed,
  embedlink: blockDataByBlockType.embed,
  file: blockDataByBlockType.file,
  fillin: blockDataByBlockType.fillin,
  h5p: blockDataByBlockType.h5p,
  heading: blockDataByBlockType.heading,
  image: blockDataByBlockType.image,
  likert: blockDataByBlockType.likert,
  list: blockDataByBlockType.list,
  mathjax: blockDataByBlockType.mathjax,
  multiplechoice: blockDataByBlockType.multiplechoice,
  numericquestion: blockDataByBlockType.numericquestion,
  openquestion: blockDataByBlockType.openquestion,
  pagebreak: blockDataByBlockType.pagebreak,
  pre: blockDataByBlockType.pre,
  quote: blockDataByBlockType.quote,
  raw: blockDataByBlockType.raw,
  scorm: blockDataByBlockType.scorm,
  sequencing: blockDataByBlockType.sequencing,
  singlechoice: blockDataByBlockType.singlechoice,
  table: blockDataByBlockType.table,
  text: blockDataByBlockType.text,
  video: blockDataByBlockType.video
};
